var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelScheduleMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 2.65625C14.0625 1.70853 13.2915 0.9375 12.3438 0.9375H12V2.34375C12 2.60263 11.7901 2.8125 11.5312 2.8125C11.2724 2.8125 11.0625 2.60263 11.0625 2.34375V0.9375H9V2.34375C9 2.60263 8.79012 2.8125 8.53125 2.8125C8.27238 2.8125 8.0625 2.60263 8.0625 2.34375V0.9375H6V2.34375C6 2.60263 5.79012 2.8125 5.53125 2.8125C5.27238 2.8125 5.0625 2.60263 5.0625 2.34375V0.9375H3V2.34375C3 2.60263 2.79012 2.8125 2.53125 2.8125C2.27238 2.8125 2.0625 2.60263 2.0625 2.34375V0.9375H1.71875C0.771031 0.9375 0 1.70853 0 2.65625V4.0625H14.0625V2.65625Z",
    fill: "url(#paint0_linear_399_272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0.46875C3 0.209875 2.79013 0 2.53125 0C2.27237 0 2.0625 0.209875 2.0625 0.46875V0.9375H3V0.46875Z",
    fill: "url(#paint1_linear_399_272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.46875C12 0.209875 11.7901 0 11.5312 0C11.2724 0 11.0625 0.209875 11.0625 0.46875V0.9375H12V0.46875Z",
    fill: "url(#paint2_linear_399_272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0.46875C9 0.209875 8.79013 0 8.53125 0C8.27237 0 8.0625 0.209875 8.0625 0.46875V0.9375H9V0.46875Z",
    fill: "url(#paint3_linear_399_272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0.46875C6 0.209875 5.79013 0 5.53125 0C5.27237 0 5.0625 0.209875 5.0625 0.46875V0.9375H6V0.46875Z",
    fill: "url(#paint4_linear_399_272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 8.1875C13.0892 8.1875 13.5944 8.28109 14.0625 8.45244V5H0V12.0312C0 12.8067 0.630844 13.4375 1.40625 13.4375H8.27547C8.21784 13.1547 8.1875 12.8621 8.1875 12.5625C8.1875 10.1501 10.1501 8.1875 12.5625 8.1875ZM10.8125 6.64062H11.5938C11.8526 6.64062 12.0625 6.8505 12.0625 7.10938C12.0625 7.36825 11.8526 7.57812 11.5938 7.57812H10.8125C10.5536 7.57812 10.3438 7.36825 10.3438 7.10938C10.3438 6.8505 10.5536 6.64062 10.8125 6.64062ZM8.03125 6.64062H8.8125C9.07137 6.64062 9.28125 6.8505 9.28125 7.10938C9.28125 7.36825 9.07137 7.57812 8.8125 7.57812H8.03125C7.77238 7.57812 7.5625 7.36825 7.5625 7.10938C7.5625 6.8505 7.77238 6.64062 8.03125 6.64062ZM3.25 11.7969H2.46875C2.20988 11.7969 2 11.587 2 11.3281C2 11.0693 2.20988 10.8594 2.46875 10.8594H3.25C3.50887 10.8594 3.71875 11.0693 3.71875 11.3281C3.71875 11.587 3.50887 11.7969 3.25 11.7969ZM3.25 9.6875H2.46875C2.20988 9.6875 2 9.47762 2 9.21875C2 8.95988 2.20988 8.75 2.46875 8.75H3.25C3.50887 8.75 3.71875 8.95988 3.71875 9.21875C3.71875 9.47762 3.50887 9.6875 3.25 9.6875ZM6.03125 11.7969H5.25C4.99113 11.7969 4.78125 11.587 4.78125 11.3281C4.78125 11.0693 4.99113 10.8594 5.25 10.8594H6.03125C6.29012 10.8594 6.5 11.0693 6.5 11.3281C6.5 11.587 6.29012 11.7969 6.03125 11.7969ZM6.03125 9.6875H5.25C4.99113 9.6875 4.78125 9.47762 4.78125 9.21875C4.78125 8.95988 4.99113 8.75 5.25 8.75H6.03125C6.29012 8.75 6.5 8.95988 6.5 9.21875C6.5 9.47762 6.29012 9.6875 6.03125 9.6875ZM6.03125 7.57812H5.25C4.99113 7.57812 4.78125 7.36825 4.78125 7.10938C4.78125 6.8505 4.99113 6.64062 5.25 6.64062H6.03125C6.29012 6.64062 6.5 6.8505 6.5 7.10938C6.5 7.36825 6.29012 7.57812 6.03125 7.57812ZM7.5625 9.21875C7.5625 8.95988 7.77238 8.75 8.03125 8.75H8.8125C9.07137 8.75 9.28125 8.95988 9.28125 9.21875C9.28125 9.47762 9.07137 9.6875 8.8125 9.6875H8.03125C7.77238 9.6875 7.5625 9.47762 7.5625 9.21875Z",
    fill: "url(#paint5_linear_399_272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 9.125C10.6671 9.125 9.125 10.6671 9.125 12.5625C9.125 14.4579 10.6671 16 12.5625 16C14.4579 16 16 14.4579 16 12.5625C16 10.6671 14.4579 9.125 12.5625 9.125ZM14.125 13.0312H12.5625C12.3036 13.0312 12.0938 12.8214 12.0938 12.5625V11C12.0938 10.7411 12.3036 10.5312 12.5625 10.5312C12.8214 10.5312 13.0312 10.7411 13.0312 11V12.0938H14.125C14.3839 12.0938 14.5938 12.3036 14.5938 12.5625C14.5938 12.8214 14.3839 13.0312 14.125 13.0312Z",
    fill: "url(#paint6_linear_399_272)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_272",
    x1: 7.03125,
    y1: 0.9375,
    x2: 7.03125,
    y2: 4.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_399_272",
    x1: 2.53125,
    y1: 0,
    x2: 2.53125,
    y2: 0.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_399_272",
    x1: 11.5312,
    y1: 0,
    x2: 11.5312,
    y2: 0.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_399_272",
    x1: 8.53125,
    y1: 0,
    x2: 8.53125,
    y2: 0.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_399_272",
    x1: 5.53125,
    y1: 0,
    x2: 5.53125,
    y2: 0.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_399_272",
    x1: 7.03125,
    y1: 5,
    x2: 7.03125,
    y2: 13.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_399_272",
    x1: 12.5625,
    y1: 9.125,
    x2: 12.5625,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelScheduleMsg);
export default __webpack_public_path__ + "static/media/selScheduleMsg.09273069059b535d8e4350539ea8d75b.svg";
export { ForwardRef as ReactComponent };